module.exports = __webpack_public_path__ + "img/gdnyzb.5c3ed8b.png";